import React, { useState, useEffect } from "react";
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
  handleSelectedProperties,
  gridForComputedIndex,
  gridForHazard,
  defaultMarks,
} from "./AniaDetailsUtils";

export const AniaNaturalEventsDetails = ({ selectedProperties: selectedProp }) => {
  const { t } = useTranslation();
  const [selectedProperties, setSelectedProperties] = useState(selectedProp);
  const [aniaRiskSliderMarks, setAniaRiskSliderMarks] = useState(defaultMarks);
  const [riskScore, setRiskScoreValue] = useState(0);
  useEffect(() => {
    handleSelectedProperties(
      "ANIA_RINDX_ITA_NE",
      selectedProp,
      setRiskScoreValue,
      setAniaRiskSliderMarks,
      setSelectedProperties,
    );
  }, [selectedProp]);

  const allocation = 0.5; // not calculated yet
  return (
    <Box m={2} mb={5}>
      {gridForComputedIndex(t, selectedProperties, riskScore, aniaRiskSliderMarks, t("climateIndex.AniaNe"))}
      {gridForHazard(
        t,
        t("riskAssessment.highWind"),
        selectedProperties?.CartaPericolositaDelVento,
        allocation,
      )}
      {gridForHazard(t, t("climateIndex.hail"), selectedProperties?.Grandine, allocation)}
    </Box>
  );
};
